import { Image } from '@/components/Image';

interface IProps {
  onClose?: () => void;
}

const CompanyModal = ({ onClose }: IProps) => {
  return (
    <div
      className="w-[480px] rounded-[20px] border border-[#f5f5f5] flex flex-col justify-between p-6 absolute top-[73px] right-[25px] bg-white shadow-[10px_20px_20px_0_rgba(0,0,0,0.16)] z-50"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex justify-between">
        <div className="text-[20px] font-extrabold">Company Information</div>
        <Image src="/icons/close.svg" alt="close" className="cursor-pointer" onClick={() => onClose?.()} height={24} width={24} />
      </div>
      <div className="flex flex-col items-start text-[16px] leading-6 font-normal mt-6">
        <div className="pb-3 border-b border-[#e5e5e5] w-full mb-3">
          <p className="text-[14px] font-medium text-[#4D4D4D]">Company</p>
          <p className="text-[16px] font-medium">INFLUDEO. Inc</p>
        </div>
        <div className="pb-3 border-b border-[#e5e5e5] w-full mb-3">
          <p className="text-[14px] font-medium text-[#4D4D4D]">CEO</p>
          <p className="text-[16px] font-medium">Park Sangyeob</p>
        </div>
        <div className="pb-3 border-b border-[#e5e5e5] w-full mb-3">
          <p className="text-[14px] font-medium text-[#4D4D4D]">Address</p>
          <p className="text-[16px] font-medium">
            20F, Office A, Times Square, 15 Yeongjung-ro <br />
            Yeongdeungpo-gu, Seoul, 07305, Republic of Korea
          </p>
        </div>
        <div className="pb-3 border-b border-[#e5e5e5] w-full mb-3">
          <p className="text-[14px] font-medium text-[#4D4D4D]">Tel</p>
          <p className="text-[16px] font-medium">+82-02-6014-8373</p>
        </div>
        <div className="pb-3 border-b border-[#e5e5e5] w-full mb-3">
          <p className="text-[14px] font-medium text-[#4D4D4D]">Business Registration Number</p>
          <p className="text-[16px] font-medium">245-81-01708</p>
        </div>
        <div className="w-full">
          <p className="text-[14px] font-medium text-[#4D4D4D]">E-commerce Registration Number</p>
          <p className="text-[16px] font-medium">2022-Seoul Mapo-2978</p>
        </div>
      </div>
    </div>
  );
};

export default CompanyModal;
